import type { ModalProps } from 'antd';
import { Modal } from 'antd';
import type { ReactNode } from 'react';
import styles from './index.module.scss';

interface MyModalProps {
  className?: ClassNames;
  open: boolean;
  title: ReactNode | string;
  cancelText?: ReactNode | string;
  actionText?: ReactNode | string;
  children: ReactNode;
  modalProps?: ModalProps;
  canClickAction?: boolean;
  onCancel?: () => void;
  onAction?: () => void | Promise<any>;
}
const MyModal = ({
  className,
  open,
  title,
  cancelText,
  actionText,
  children,
  modalProps,
  canClickAction = true,
  onCancel = () => {},
  onAction = () => {},
}: MyModalProps) => {
  const [loading, setLoading] = useState(false);

  const handleAction = useCallback(async () => {
    if (loading || !canClickAction) return;
    setLoading(true);
    await onAction();
    setLoading(false);
  }, [onAction, loading, canClickAction]);

  return (
    <Modal
      className={cls(styles.myModal, className)}
      open={open}
      closable={false}
      maskClosable={false}
      footer={null}
      onCancel={onCancel}
      width={666}
      {...modalProps}
    >
      <div className={styles.header}>
        <div className={styles.cancel} onClick={onCancel}>
          {cancelText}
        </div>
        <div className={styles.title}>{title}</div>
        <div
          className={cls(
            styles.action,
            loading && styles.actionLoading,
            !canClickAction && styles.actionDisabled
          )}
          onClick={handleAction}
        >
          {actionText}
        </div>
      </div>
      <div>{children}</div>
    </Modal>
  );
};
export default MyModal;
